import React from "react";
import "./styles.scss";
import Button from "../../../common/button";
import { Divider } from "@mui/material";

// import PaymentIcon from "../../../assets/icons/Afterpay_Badge_BlackonMint 1.svg";
// import InfoImage from "../../../assets/icons/material-symbols-light_info-outline.svg";
// import Tooltip from "../../../common/tooltip";

const OrderSummary = (props) => {
  const {
    isValid,
    currency,
    payment_image,
    shipping,
    sub_total,
    handleProceedToCheckout,
    products,
  } = props;

  // Format as currency with CAD currency symbol
  const formattedPrice = (price) => {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
    }).format(price);
  };

  return (
    <div className="order-summary-container">
      <h3 className="title" style={{ textAlign: isValid ? "center" : "left" }}>
        Order summary
      </h3>
      {!isValid ? (
        <div className="summary">
          {/* <p className="section">
            <span className="left">Sub - Total</span>
            <span className="right">
              {formattedPrice(sub_total)} {currency}
            </span>
          </p> */}
          <div className="summary-section">
            {products?.length
              ? products?.map((item) => {
                  return (
                    <div key={item?.id}>
                      <p>
                        {item?.product_count} x {item?.name}
                      </p>
                      <span>
                        {item?.currency_symbol} {item?.total_price}{" "}
                        {item?.currency}
                      </span>
                    </div>
                  );
                })
              : null}
          </div>

          <p className="section">
            <span className="left">Shipping</span>
            <span className="right">
              {shipping}
              {/* <p className="location">
                <span>Shipping to</span>
                <span className="bold"> American Samoa.</span>
              </p> */}
            </span>
          </p>
        </div>
      ) : null}
      {!isValid ? <Divider variant="middle" component="div" /> : null}
      <div className="sub-total">
        <span className="left">Sub - Total</span>
        <span className="right">
          {formattedPrice(sub_total)} {currency}
        </span>
      </div>
      {!isValid ? (
        <>
          {/* <div className="payment-container">
            <span>or 4 Payments of $445.00 with</span>
            <div className="image">
              <img src={PaymentIcon} alt="payment" />
            </div>
            <div className="image">
              <Tooltip title="info">
                <img src={InfoImage} alt="info" />
              </Tooltip>
            </div>
          </div> */}
          <div className="image">
            <img src={payment_image} alt="info" />
          </div>
        </>
      ) : null}
      <div className="btn">
        <Button onClick={() => handleProceedToCheckout()}>
          Proceed to checkout
        </Button>
      </div>
    </div>
  );
};

export default OrderSummary;
